import React, { useRef, useEffect } from "react";
import UserList from "./UserList";

function UserModal({
  open,
  handleModal,
  id,
  teamMembers,
  data,
  setCheck,
  teamName,
  teamCreatror,
}) {
  const modalRef = useRef(null);
  useEffect(() => {
    modalRef?.current?.classList.add("animate__zoomIn");

    modalRef?.current?.addEventListener("animationend", (event) => {
      modalRef?.current?.classList.remove("animate__zoomIn");
    });
  }, [open]);

  const handleClose = () => {
    setCheck(false);
    modalRef?.current?.classList.add("animate__zoomOut");
    modalRef?.current?.addEventListener("animationend", (event) => {
      handleModal();
    });
  };

  return open ? (
    <div
      ref={modalRef}
      className={`fixed inset-0 z-10 flex flex-col items-center justify-center  animate__animated bg-black/10 backdrop-blur-sm`}
    >
      <button
        className="fixed right-6 top-4 text-2xl  text-violet-900"
        onClick={handleClose}
      >
        X
      </button>
      <div>
        <h1 className="mt-20 mb-8 text-3xl font-extrabold text-violet-600">
          Assign member to {teamName} team
        </h1>
      </div>
      <UserList
        teamName={teamName}
        data={data}
        teamMembers={teamMembers}
        id={id}
        teamCreatror={teamCreatror}
      />
    </div>
  ) : null;
}

export default UserModal;
